const extractLeafPaths = (rows, columnFieldCount, metricName) => {
  const paths = [];
  rows.forEach((row) => {
    var _a;
    if (row.source !== "leaf") return;
    if (metricName === void 0) {
      const colChildren = ((_a = row.values) != null ? _a : []).filter((v) => v.source === "col-leaf");
      if (columnFieldCount > 0 && colChildren.length > 0) {
        colChildren.forEach((value) => {
          const colKeys = value.key.length === columnFieldCount + 1 ? value.key.slice(0, -1) : value.key;
          if (colKeys.length !== columnFieldCount) return;
          paths.push({
            keys: [...row.key, ...colKeys],
            value: 1
          });
        });
      } else if (row.key.length > 0) {
        paths.push({ keys: [...row.key], value: 1 });
      }
      return;
    }
    row.values.forEach((value) => {
      if (value.source !== "col-leaf" && value.source !== "row-leaf") return;
      if (value.key.length !== columnFieldCount + 1) return;
      if (value.key[value.key.length - 1] !== metricName) return;
      const numericValue = Number(value.value);
      if (!Number.isFinite(numericValue) || numericValue <= 0) return;
      paths.push({
        keys: [...row.key, ...value.key.slice(0, -1)],
        value: numericValue
      });
    });
  });
  return paths;
};
export default extractLeafPaths;
